<template>
  <div class="contact-import-validate-step">
    <div class="box">
      <h2 class="title is-5">Validar archivo</h2>
      <p class="subtitle is-6">
        Revisar que el archivo tenga el formato requerido.
      </p>

      <div v-if="file" class="notification is-info is-light">
        <strong>Archivo seleccionado:</strong>
        <br />
        {{ file.name }}
      </div>

      <div v-else class="notification is-warning is-light">
        Todavía no se seleccionó ningún archivo.
      </div>

      <b-button
        type="is-primary"
        icon-pack="fas"
        icon-left="check"
        :loading="loading"
        :disabled="!file || loading"
        @click="$emit('validate')"
      >
        Validar archivo
      </b-button>

      <div v-if="validation" class="mt-4 validation-scroll">
        <div class="columns">
          <div class="column">
            <div class="box">
              <p class="heading">Filas leídas</p>
              <p class="title is-4">
                {{ validation.totalRows }}
              </p>
            </div>
          </div>

          <div class="column">
            <div class="box">
              <p class="heading">Columnas detectadas</p>
              <p class="title is-4">
                {{ validation.detectedColumns }}
              </p>
            </div>
          </div>

          <div class="column">
            <div
              class="notification"
              :class="
                validation.isValid
                  ? 'is-success is-light'
                  : 'is-danger is-light'
              "
            >
              <strong>Estado</strong>
              <br />
              {{
                validation.isValid ? "Archivo válido" : "Archivo con errores"
              }}
            </div>
          </div>
        </div>

        <div class="box">
          <h3 class="title is-6">Columnas esperadas</h3>

          <div class="columns is-multiline">
            <div
              v-for="column in validation.columns"
              :key="column.key"
              class="column is-one-third"
            >
              <div
                class="column-status"
                :class="
                  column.found
                    ? 'is-valid'
                    : column.required
                    ? 'is-invalid'
                    : 'is-optional'
                "
              >
                <strong>{{ column.label }}</strong>

                <span
                  v-if="!column.required"
                  class="tag is-warning is-light ml-2"
                >
                  opcional
                </span>

                <br />

                <small>
                  {{ column.found ? "Encontrada" : "No encontrada" }}
                </small>
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="validation.errors && validation.errors.length"
          class="notification is-danger is-light"
        >
          <strong>Errores encontrados:</strong>

          <ul class="mt-2">
            <li v-for="(error, index) in validation.errors" :key="index">
              {{ error }}
            </li>
          </ul>
        </div>

        <div
          v-if="validation.warnings && validation.warnings.length"
          class="notification is-warning is-light"
        >
          <strong>Advertencias:</strong>

          <ul class="mt-2">
            <li v-for="(warning, index) in validation.warnings" :key="index">
              {{ warning }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContactImportValidateStep",

  props: {
    file: {
      type: Object,
      default: null,
    },

    validation: {
      type: Object,
      default: null,
    },

    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.mt-2 {
  margin-top: 0.5rem;
}

.mt-4 {
  margin-top: 1rem;
}

.ml-2 {
  margin-left: 0.5rem;
}

.column-status {
  border: 1px solid #dbdbdb;
  border-radius: 4px;
  padding: 10px;
  font-size: 13px;
  min-height: 72px;
}

.column-status.is-valid {
  background: #effaf3;
  border-color: #48c774;
}

.column-status.is-invalid {
  background: #feecf0;
  border-color: #f14668;
}

.column-status.is-optional {
  background: #fff8e1;
  border-color: #ffdd57;
}

.validation-scroll {
  max-height: calc(100vh - 390px);
  overflow-y: auto;
  padding-right: 0.5rem;
  padding-bottom: 1rem;
}

.validation-scroll::-webkit-scrollbar {
  width: 8px;
}

.validation-scroll::-webkit-scrollbar-track {
  background: #f5f5f5;
  border-radius: 4px;
}

.validation-scroll::-webkit-scrollbar-thumb {
  background: #b5b5b5;
  border-radius: 4px;
}

.validation-scroll::-webkit-scrollbar-thumb:hover {
  background: #8f8f8f;
}
</style>